export default function ServicesSection() {
  return (
    <section className="py-24 bg-[#F0F8FF]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Area */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-16 gap-6">
          <h3 className="text-5xl font-bold text-gray-900 max-w-md" style={{ fontFamily: "'Playfair Display', serif" }}>
            Health Insurance Solutions
          </h3>
          <p className="text-gray-600 text-base max-w-xl leading-relaxed">
            Comprehensive health coverage options tailored for <strong>Kerrville residents</strong> and businesses. 
            From private health insurance to Medicare and group plans, we protect your health and financial wellbeing in Kerr County.
          </p>
        </div>

        {/* Three-Column Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {/* Left Column - Private Health Insurance */}
          <div className="bg-[#0077B6] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all">
            <div className="p-8">
              <h4 className="text-2xl font-bold text-white mb-4">Private Health Insurance</h4>
              <ul className="text-white/80 text-sm space-y-2 mb-6">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-[#00D9FF]"></i>
                  <span>Individual Plans</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-[#00D9FF]"></i>
                  <span>Family Coverage</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-[#00D9FF]"></i>
                  <span>Short-Term Plans</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-[#00D9FF]"></i>
                  <span>Catastrophic Coverage</span>
                </li>
              </ul>
            </div>
            <div className="w-full h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/982384c0db217d5a5ed8278eeb5373bf.jpg"
                alt="Private Health Insurance for Individuals and Families"
                title="Private Health Insurance Kerrville"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-8">
              <a
                href="/private-health-insurance-kerrville-tx"
                className="block w-full text-center px-6 py-3 bg-white text-[#0077B6] text-sm font-semibold rounded-full hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Explore Plans
              </a>
            </div>
          </div>

          {/* Middle Column - Group Health Insurance */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all">
            <div className="p-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#00D9FF]/10 rounded-full mb-4">
                <i className="ri-shield-star-line text-[#00D9FF] text-sm"></i>
                <span className="text-[#00D9FF] text-xs font-semibold">POPULAR</span>
              </div>
              <div className="w-20 h-20 mx-auto mb-6 bg-[#F0F8FF] rounded-full flex items-center justify-center">
                <i className="ri-team-line text-[#0077B6] text-4xl"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-3 text-center">Group Health Insurance</h4>
              <p className="text-gray-600 text-sm text-center mb-6 leading-relaxed">
                Affordable employee health benefits for Kerrville businesses. Attract and retain top talent with comprehensive group coverage.
              </p>
              <a
                href="/group-health-insurance-kerrville-tx"
                className="block w-full text-center px-6 py-3 bg-[#0077B6] text-white text-sm font-semibold rounded-full hover:bg-[#005F8C] transition-all whitespace-nowrap cursor-pointer"
              >
                Get Quote
              </a>
            </div>
            <div className="w-full h-48">
              <img
                src="https://readdy.ai/api/search-image?query=diverse%20group%20of%20business%20professionals%20and%20employees%20standing%20together%20in%20modern%20office%20representing%20group%20health%20insurance%20benefits%20clean%20professional%20background%20with%20soft%20blue%20tones%20teamwork%20and%20healthcare%20protection%20concept&width=400&height=300&seq=group-health-001&orientation=landscape"
                alt="Group Health Insurance for Businesses"
                title="Group Health Insurance Kerrville"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column - Medicare */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all">
            <div className="p-8">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#0077B6]/10 rounded-full mb-4">
                <i className="ri-heart-pulse-line text-[#0077B6] text-sm"></i>
                <span className="text-[#0077B6] text-xs font-semibold">SENIORS</span>
              </div>
              <div className="w-20 h-20 mx-auto mb-6 bg-[#F0F8FF] rounded-full flex items-center justify-center">
                <i className="ri-hospital-line text-[#0077B6] text-4xl"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-3 text-center">Medicare Plans</h4>
              <p className="text-gray-600 text-sm text-center mb-6 leading-relaxed">
                Expert Medicare guidance for Kerrville seniors. Medicare Advantage, Supplement, and Part D prescription drug coverage.
              </p>
              <a
                href="/medicare-kerrville-tx"
                className="block w-full text-center px-6 py-3 bg-[#0077B6] text-white text-sm font-semibold rounded-full hover:bg-[#005F8C] transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
              </a>
            </div>
            <div className="w-full h-48">
              <img
                src="https://readdy.ai/api/search-image?query=caring%20senior%20couple%20smiling%20with%20healthcare%20professional%20discussing%20Medicare%20plans%20in%20comfortable%20office%20setting%20representing%20senior%20health%20insurance%20clean%20professional%20background%20with%20soft%20blue%20tones%20warm%20caring%20atmosphere&width=400&height=300&seq=medicare-001&orientation=landscape"
                alt="Medicare Plans for Seniors"
                title="Medicare Insurance Kerrville"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Additional Services List */}
        <div className="mt-16 bg-white rounded-2xl p-10 shadow-lg">
          <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center">Complete Health Coverage Options</h4>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-[#F0F8FF] rounded-full flex items-center justify-center">
                <i className="ri-medicine-bottle-line text-[#0077B6] text-2xl"></i>
              </div>
              <h5 className="font-semibold text-gray-900 text-sm mb-1">Prescription Drug Plans</h5>
              <p className="text-gray-600 text-xs">Medicare Part D coverage</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-[#F0F8FF] rounded-full flex items-center justify-center">
                <i className="ri-tooth-line text-[#0077B6] text-2xl"></i>
              </div>
              <h5 className="font-semibold text-gray-900 text-sm mb-1">Dental Insurance</h5>
              <p className="text-gray-600 text-xs">Comprehensive dental care</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-[#F0F8FF] rounded-full flex items-center justify-center">
                <i className="ri-eye-line text-[#0077B6] text-2xl"></i>
              </div>
              <h5 className="font-semibold text-gray-900 text-sm mb-1">Vision Insurance</h5>
              <p className="text-gray-600 text-xs">Eye care coverage</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-[#F0F8FF] rounded-full flex items-center justify-center">
                <i className="ri-wheelchair-line text-[#0077B6] text-2xl"></i>
              </div>
              <h5 className="font-semibold text-gray-900 text-sm mb-1">Disability Insurance</h5>
              <p className="text-gray-600 text-xs">Income protection</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
